import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AskTheAuthorComponent } from './ask-the-author.component';
import { AskTheAuthorButtonComponent } from './ask-the-author-button/ask-the-author-button.component';
import { AskTheAuthorListComponent } from './ask-the-author-list/ask-the-author-list.component';
import { AskTheAuthorListItemComponent } from './ask-the-author-list/ask-the-author-list-item/ask-the-author-list-item.component';



@NgModule({
  declarations: [
    AskTheAuthorComponent,
    AskTheAuthorButtonComponent,
    AskTheAuthorListComponent,
    AskTheAuthorListItemComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AskTheAuthorComponent
  ]
})
export class AskTheAuthorModule { }
